import { createFileRoute } from "@tanstack/react-router";
import { OnboardingScreen } from "@/components/onboarding/onboarding-screen";
export const Route = createFileRoute("/onboarding")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { org?: string; project?: string } => ({
    org: typeof search.org === "string" ? search.org : undefined,
    project: typeof search.project === "string" ? search.project : undefined,
  }),
  component: () => {
    const { org, project } = Route.useSearch();
    return <OnboardingScreen orgId={org} projectId={project} />;
  },
});
